import React, { useContext, useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";

import Header from "../components/Header/Header";
import MobileNavbar from "../components/Header/Mobile/MobileNavbar";
import MobileHeader from "../components/Header/Mobile/MobileHeader";
import ScrollTop from "../components/shared/ScrollTop";
import ProductSidebarWrapper from "../components/Product/ProductPage/ProductSidebarWrapper";
import Footer from "../components/Footer/Footer";
import { toFarsiNumber } from "../helper/helper";
import { getData, postData } from "../services/API";
import { ProgressSpinner } from "primereact/progressspinner";
import { UserData } from "../contexts/UserInfoContext";
import { CartDataContext } from "../contexts/CartContext";

const SuccessPayment = () => {
  const [order, setOrder] = useState({});
  const [loading, setLoading] = useState(true);
  const { user, setUser } = useContext(UserData);
  const { cart, setCart, loaded, err } = useContext(CartDataContext);

  const [searchParams, setSearchParams] = useSearchParams();
  const status = searchParams.get("status");
  const type = searchParams.get("type");
  const trans_id = searchParams.get("transaction_id");
  const wallet = searchParams.get("wallet");

  useEffect(() => {
    // // update profile
    // getData("/user/profile", {}).then((res) => {
    //   setUser(res.data);
    // });
    // // update cart
    getData("/shop/cart/index", {}, true)
      .then((res) => {
        setCart(res.data);
      })
      .catch((err) => {});
  }, []);

  return (
    <div className="flex flex-col items-center justify-center mx-auto">
      <Header />
      <MobileNavbar />
      <MobileHeader />
      <ScrollTop />

      <div className="w-full xl:max-w-[1300px] flex flex-col justify-center mt-5 gap-8 mb-20 px-3 2xl:px-0">
        <ProductSidebarWrapper
          className="!w-full"
          titleClassName="!text-[20px]"
          contentClassName="!mt-[6px]"
          title={status === "success" ? "پرداخت موفق" : "پرداخت ناموفق"}
          line={true}
        ></ProductSidebarWrapper>

        {status === "success" ? (
          <div className="w-full flex flex-col rounded-xl p-4 md:p-6 items-center gap-4">
            {wallet === "true" ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="w-32 h-32 stroke-blue-500"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M21 12a2.25 2.25 0 0 0-2.25-2.25H15a3 3 0 1 1-6 0H5.25A2.25 2.25 0 0 0 3 12m18 0v6a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 18v-6m18 0V9M3 12V9m18-3a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 9m18 0V6a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 6v3"
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="w-32 h-32 stroke-green-600"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                />
              </svg>
            )}

            <span className={`text-2xl font-black ${wallet === "true" ? "text-blue-500" : "text-green-600"}`}>
              {wallet === "true" ? "پرداخت از کیف پول با موفقیت انجام شد" : "پرداخت با موفقیت انجام شد"}
            </span>

            {wallet === "true" && (
              <div className="flex items-center gap-2 bg-blue-950 border border-blue-700 text-blue-300 text-sm rounded-xl px-4 py-2">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5 shrink-0">
                  <path strokeLinecap="round" strokeLinejoin="round" d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z" />
                </svg>
                <span>مبلغ سفارش از موجودی کیف پول شما کسر شد</span>
              </div>
            )}

            {type === "ticket" ? (
              <p className="text-gray-400">
                خرید شما با موفقت انجام شد برای مشاهده بلیط های خود بر روی دکمه
                زیر کلیک کنید
              </p>
            ) : type === "website_order" ? (
              <p className="text-gray-400">
                خرید و سفارش پکیج طراحی سایت شما با موفقت ثبت شد برای مشاهده
                اطلاعات بیشتر بر روی دکمه زیر کلیک کنید
              </p>
            ) : type === "payment" ? (
              <p className="text-gray-400">
                جهت انجام مصاحبه منتظر تماس مشاورین یونی بست باشید
              </p>
            ) : (
              <p className="text-gray-400">
                {wallet === "true"
                  ? "پکیج های شما فعال شد، برای مشاهده بر روی دکمه زیر کلیک کنید"
                  : "خرید شما با موفقت انجام شد برای مشاهده پکیج های خود بر روی دکمه زیر کلیک کنید"}
              </p>
            )}

            {type === "ticket" ? (
              <Link
                to={"/user/my-tickets?type=my"}
                className="py-2 px-6 bg-gradient-to-tl from-green-700 to-green-400 hover:opacity-80 transition-all text-white duration-300 rounded-xl "
              >
                بلیط های من
              </Link>
            ) : type === "website_order" ? (
              <Link
                to={"/user/orders"}
                className="py-2 px-6 bg-gradient-to-tl from-green-700 to-green-400 hover:opacity-80 transition-all text-white duration-300 rounded-xl "
              >
                سایت های من
              </Link>
            ) : (
              <Link
                to={"/user/academy/active-subscription"}
                className={`py-2 px-6 bg-gradient-to-tl ${wallet === "true" ? "from-blue-700 to-blue-400" : "from-green-700 to-green-400"} hover:opacity-80 transition-all text-white duration-300 rounded-xl`}
              >
                پکیج های من
              </Link>
            )}
          </div>
        ) : (
          <div className="w-full flex flex-col items-center gap-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-32 h-32 stroke-red-600"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"
              />
            </svg>

            <span className="text-2xl text-red-600 font-black">
              خطا در عملیات پرداخت
            </span>

            {/* <div className="flex text-gray-800 flex-col items-center gap-2">
              <span className="text-gray-700">شماره پیگیری</span>

              <span className="font-bold">
                {order?.transaction?.code
                  ? toFarsiNumber(order.transaction.code)
                  : toFarsiNumber(trans_id)}
              </span>
            </div> */}

            <p className="text-gray-400">
              وجه کسر شده از حساب شما تا {toFarsiNumber(72)} ساعت کاری به حساب
              شما باز خواهد گشت در غیر این صورت با پشتیبانی در تماس باشید.
            </p>
            <Link
              to={"/user/new-ticket"}
              className="py-2 px-6 bg-gradient-to-tl from-green-700 to-green-400 hover:opacity-80 transition-all text-white duration-300 rounded-xl "
            >
              پشتیبانی
            </Link>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default SuccessPayment;
